<template>
  <div id="principal">
    <ItemLista height="83" :ativo="fornecedor.expandido">
      <div class="col-6 d-flex align-center pa-0 pr-3">
        <div class="cursor-pointer" @click="selecionar(fornecedor)">
          <v-icon v-if="esta_selecionado" color="#142454" v-text="'mdi-checkbox-marked'" />
          <v-icon v-else color="#142454" v-text="'mdi-checkbox-blank-outline'" />
        </div>

        <div class="cursor-pointer px-1" @click="expandir(fornecedor)">
          <v-icon v-if="fornecedor.expandido" v-text="'mdi-chevron-down'" />
          <v-icon v-else v-text="'mdi-chevron-right'" />
        </div>

        <p
          class="coluna-principal text-truncate"
          v-text="fornecedor.nome_fornecedor"
          :title="fornecedor.nome_fornecedor" />
      </div>

      <div class="col-3 pa-0">
        <p class="titulo-informacao" v-text="'Última compra'" />

        <p class="informacao">
          <span class="descricao">Data: </span>
          <span class="valor" v-text="fornecedor.ultima_compra.data" />
        </p>

        <p class="informacao">
          <span class="descricao">Departamentos atendidos: </span>
          <span class="valor" v-text="fornecedor.ultima_compra.departamentos_atendidos" />
        </p>

        <p class="informacao">
          <span class="descricao">Categorias atendidas: </span>
          <span class="valor" v-text="fornecedor.ultima_compra.categorias_atendidas" />
        </p>
      </div>

      <div class="col-3 pa-0">
        <p class="titulo-informacao" v-text="'Cotação Atual'" />

        <p class="informacao">
          <span class="descricao">Departamentos que atende: </span>
          <span class="valor" v-text="fornecedor.cotacao_atual.departamentos_atendidos" />
        </p>

        <p class="informacao">
          <span class="descricao">Categorias que atende: </span>
          <span class="valor" v-text="fornecedor.cotacao_atual.categorias_atendidas" />
        </p>

        <p class="informacao">
          <span class="descricao">Quantidade a ser cotada: </span>
          <span class="valor" v-text="fornecedor.cotacao_atual.qtd_cotada" />
        </p>
      </div>
    </ItemLista>

    <v-expand-transition id="departamentos-do-fornecedor">
      <DepartamentosDoFornecedor
        :ativo="fornecedor.expandido"
        :fornecedor="fornecedor"
        :selecionar-fornecedor-callback="selecionar"
      />
    </v-expand-transition>
  </div>
</template>

<script>
import DepartamentosDoFornecedor from "./DepartamentosDoFornecedor";
import ItemLista from "./ItemLista";

export default {
  name: "Fornecedor",
  components: {
    ItemLista,
    DepartamentosDoFornecedor
  },
  props: {
    fornecedor: Object,
    esta_selecionado: Boolean,
    selecionar: Function,
    expandir: Function
  },
  data: () => ({
    todo_fornecedor_selecionado: false
  })
}
</script>

<style scoped>
</style>
